import { Deserializable } from '../protocols/deserializable';
import { InvestmentInstruction } from './investment-instruction';
import { AccountDetails } from './account-details';

export class InvestmentInstructions implements Deserializable {
  public id!: number;
  public accountDetails!: AccountDetails;
  public lastUpdatedDate!: string | null;
  public investmentInstructions!: InvestmentInstruction[];

  onDeserialize() {
    if (!!this.investmentInstructions) {
      this.investmentInstructions = window.injector.Deserialize.arrayOf(
        InvestmentInstruction,
        this.investmentInstructions
      );
      this.investmentInstructions.sort((a, b) => a.fundId - b.fundId);
    }

    if (!!this.accountDetails) {
      this.accountDetails = window.injector.Deserialize.instanceOf(AccountDetails, this.accountDetails);
    }
  }
}
